module.exports = __webpack_public_path__ + "img/_Small-Vertical-Rectangular-Attachment.cbd87c67.jpg";